<template>
  <div class="vx-row">
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div class="w-full">
      <div
        slot="no-body"
        class="tabs-container inventory_tabSec"
        id="view-customer-tab"
      >
        <vs-tabs
          alignment="fixed"
          v-model="activeTab"
          class="tab-action-btn-fill-conatiner"
        >
          <vs-tab :label="$t('setup.label.TemplateDefinition')">
            <vx-card>
              <vs-table
                :max-items="paginationItems[1]"
                pagination
                :data="broadcasters"
                :description="false"
                @selected="handleSelected1"
                search
                :description-items="paginationItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="heading">
                    {{ $t("setup.label.TemplateDefinition") }}
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="$router.push({ name: 'Create Template' })"
                      size="small"
                      >{{
                        $t("setup.label.CreateTemplateDefinition")
                      }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("setup.label.TemplateName") }}</vs-th>
                  <vs-th>{{ $t("setup.label.Delimiter") }}</vs-th>
                  <vs-th>{{ $t("setup.label.NumberOfFields") }}</vs-th>
                  <vs-th>{{ $t("setup.label.HeaderRecorderType") }}</vs-th>
                  <vs-th>{{ $t("setup.label.EventRecordType") }}</vs-th>
                  <vs-th>{{ $t("setup.label.ServiceCode") }}</vs-th>
                  <vs-th>{{ $t("setup.label.ProductCode") }}</vs-th>
                  <vs-th class="tHeadCenter">{{
                    $t("setup.label.Actions")
                  }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="broadcasters"
                    v-for="(broadcasters, index) in data"
                  >
                    <vs-td :data="broadcasters.templateName">{{
                      broadcasters.templateName
                    }}</vs-td>
                    <vs-td :data="broadcasters.delimiter">{{
                      broadcasters.delimiter
                    }}</vs-td>
                    <vs-td :data="broadcasters.numberOfFields">{{
                      broadcasters.numberOfFields
                    }}</vs-td>
                    <vs-td :data="broadcasters.headerecordtype">{{
                      broadcasters.headerecordtype
                    }}</vs-td>
                    <vs-td :data="broadcasters.eventrecordtype">{{
                      broadcasters.eventrecordtype
                    }}</vs-td>
                    <vs-td :data="broadcasters.serviceCode">{{
                      broadcasters.serviceCode || "-"
                    }}</vs-td>
                    <vs-td :data="broadcasters.productCode">{{
                      broadcasters.productCode || "-"
                    }}</vs-td>

                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <feather-icon
                          icon="EditIcon"
                          :title="$t('setup.label.Edit')"
                          svgClasses="w-5 h-5  stroke-current cursor orange_icon"
                          @click.stop="
                            EditTemplateData(broadcasters.templateId)
                          "
                          class="icon_row"
                        />

                        <feather-icon
                          icon="TrashIcon"
                          :title="$t('setup.label.Delete')"
                          svgClasses="w-5 h-5 text-danger stroke-current cursor "
                          @click.stop="
                            // stateChange('broadcasters');
                            editJobsPopup = true;
                            delId = broadcasters.templateId;
                          "
                          class="icon_row"
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </vx-card>
          </vs-tab>
          <vs-tab :label="$t('setup.label.UOM')">
            <vx-card>
              <vs-table
                :max-items="paginationItems[1]"
                pagination
                :data="hardwareUomList"
                :description="false"
                @selected="handleSelected"
                search
                :description-items="paginationItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="heading">
                    {{ $t("setup.label.UOM(Unit Of measurement)") }}
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="$router.push({ name: 'Create UOM' })"
                      size="small"
                      >{{ $t("setup.label.CreateUOM") }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("setup.label.Id") }}</vs-th>
                  <vs-th>{{ $t("setup.label.Name") }}</vs-th>
                  <vs-th>{{ $t("setup.label.Description") }}</vs-th>
                  <vs-th class="tHeadCenter">{{
                    $t("setup.label.Action")
                  }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="hardwareUomList"
                    v-for="(hardwareUomList, index) in data"
                  >
                    <vs-td :data="hardwareUomList.id">{{
                      hardwareUomList.id
                    }}</vs-td>
                    <vs-td :data="hardwareUomList.Name">{{
                      hardwareUomList.Name
                    }}</vs-td>

                    <vs-td :data="hardwareUomList.Description">{{
                      hardwareUomList.Description
                    }}</vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <feather-icon
                          icon="EditIcon"
                          :title="$t('setup.label.Edit')"
                          svgClasses="w-5 h-5  stroke-current cursor orange_icon"
                          @click.stop="editCreateDevice(hardwareUomList.id)"
                          class="icon_row"
                        />
                        <feather-icon
                          icon="TrashIcon"
                          :title="$t('setup.label.Delete')"
                          svgClasses="w-5 h-5 text-danger stroke-current cursor"
                          @click.stop="
                            editJobsUomPopup = true;
                            deleatId = hardwareUomList.id;
                          "
                          class="icon_row"
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="centerx">
                <vs-popup
                  classContent="popup-example"
                  :title="$t('setup.label.DeleteUOM')"
                  :active.sync="editJobsUomPopup"
                  class="popup-close small-popup"
                >
                  <div class="center">
                    <img src="@/assets/images/pages/delete.svg" />
                    <div class="success-msg">
                      {{ $t("system.label.areYouSureDelete") }}
                    </div>
                  </div>

                  <div class="center">
                    <span class="p-2">
                      <vs-button
                        type="border"
                        @click="editJobsUomPopup = false"
                        >{{ $t("system.label.cancel") }}</vs-button
                      ></span
                    >

                    <span class="p-2">
                      <vs-button @click="deleteUomTeam(deleatId)">{{
                        $t("system.label.confirm")
                      }}</vs-button>
                    </span>
                  </div>
                  <div style="height: 20px"></div>
                </vs-popup>
              </div>
            </vx-card>
          </vs-tab>
          <vs-tab :label="$t('setup.label.RUM')">
            <vx-card>
              <vs-table
                :max-items="paginationItems[1]"
                pagination
                :data="provisioningRumList"
                :description="false"
                @selected="handleSelected2"
                search
                :description-items="paginationItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="heading">
                    {{ $t("setup.label.RUM(RatableUsageMetric)") }}
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="$router.push({ name: 'Create RUM' })"
                      size="small"
                      >{{ $t("setup.label.CreateRUM") }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("setup.label.Id") }}</vs-th>
                  <vs-th>{{ $t("setup.label.ChargeName") }}</vs-th>
                  <vs-th>{{ $t("setup.label.TemplateName") }}</vs-th>
                  <vs-th>{{ $t("setup.label.RumName") }}</vs-th>
                  <vs-th>{{ $t("setup.label.RumExpression") }}</vs-th>
                  <vs-th class="tHeadCenter">{{
                    $t("setup.label.Action")
                  }}</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="provisioningRumList"
                    v-for="(provisioningRumList, index) in data"
                  >
                    <vs-td :data="provisioningRumList.id">{{
                      provisioningRumList.id
                    }}</vs-td>
                    <vs-td :data="provisioningRumList.chargeCode">{{
                      provisioningRumList.chargeCode
                    }}</vs-td>
                    <vs-td :data="provisioningRumList.templateName">{{
                      provisioningRumList.templateName
                    }}</vs-td>
                    <vs-td :data="provisioningRumList.rumName">{{
                      provisioningRumList.rumName
                    }}</vs-td>
                    <vs-td :data="provisioningRumList.rumExpression">{{
                      provisioningRumList.rumExpression
                    }}</vs-td>
                    <vs-td class="whitespace-no-wrap">
                      <div class="container_img">
                        <feather-icon
                          icon="EditIcon"
                          :title="$t('setup.label.Edit')"
                          svgClasses="w-5 h-5 stroke-current cursor orange_icon"
                          @click.stop="
                            editCreateCommand(provisioningRumList.id)
                          "
                          class="icon_row"
                        />
                        <feather-icon
                          icon="TrashIcon"
                          :title="$t('setup.label.Delete')"
                          svgClasses="w-5 h-5 text-danger stroke-current cursor"
                          @click.stop="
                            editJobsRumPopup = true;
                            delId = provisioningRumList.id;
                          "
                          class="icon_row"
                        />
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="centerx">
                <vs-popup
                  classContent="popup-example"
                  :title="$t('setup.label.DeleteRUM')"
                  :active.sync="editJobsRumPopup"
                  class="popup-close small-popup"
                >
                  <div class="center">
                    <img src="@/assets/images/pages/delete.svg" />
                    <div class="success-msg">
                      {{ $t("system.label.areYouSureDelete") }}
                    </div>
                  </div>

                  <div class="center">
                    <span class="p-2">
                      <vs-button
                        type="border"
                        @click="editJobsRumPopup = false"
                        >{{ $t("system.label.cancel") }}</vs-button
                      ></span
                    >

                    <span class="p-2">
                      <vs-button @click="deleteRumTeam(delId)">{{
                        $t("system.label.confirm")
                      }}</vs-button>
                    </span>
                  </div>
                  <div style="height: 20px"></div>
                </vs-popup>
              </div>
            </vx-card>
          </vs-tab>
          <vs-tab :label="$t('setup.label.TimePeriod')">
            <vx-card>
              <vs-table
                :max-items="paginationItems[1]"
                pagination
                :data="timeList"
                :description="false"
                search
                :description-items="paginationItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="heading">
                    {{ $t("setup.label.TimePeriod") }}
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="$router.push({ name: 'Create Time Model' })"
                      size="small"
                      >{{ $t("setup.label.CreateTimePeriod") }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("setup.label.TimeModelName") }}</vs-th>
                  <vs-th>{{ $t("setup.label.StartYear") }}</vs-th>
                  <vs-th>{{ $t("setup.label.EndYear") }}</vs-th>
                  <vs-th>{{ $t("setup.label.StartMonth") }}</vs-th>
                  <vs-th>{{ $t("setup.label.EndMonth") }}</vs-th>
                  <vs-th>{{ $t("setup.label.StartDay") }}</vs-th>
                  <vs-th>{{ $t("setup.label.EndDay") }}</vs-th>
                  <vs-th>{{ $t("setup.label.StartTime") }}</vs-th>
                  <vs-th>{{ $t("setup.label.EndTime") }}</vs-th>
                  <!-- <vs-th>{{ $t("label.heading.actions") }}</vs-th> -->
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="Timemodel"
                    v-for="(Timemodel, index) in data"
                  >
                    <vs-td :data="Timemodel.timeModelName">{{
                      Timemodel.timeModelName
                    }}</vs-td>

                    <vs-td :data="Timemodel.startYear">{{
                      Timemodel.startYear
                    }}</vs-td>
                    <vs-td :data="Timemodel.endYear">{{
                      Timemodel.endYear
                    }}</vs-td>
                    <vs-td :data="Timemodel.startMonth">{{
                      Timemodel.startMonth
                    }}</vs-td>
                    <vs-td :data="Timemodel.endMonth">{{
                      Timemodel.endMonth
                    }}</vs-td>
                    <vs-td :data="Timemodel.startDay">{{
                      Timemodel.startDay
                    }}</vs-td>
                    <vs-td :data="Timemodel.endDay">{{
                      Timemodel.endDay
                    }}</vs-td>
                    <vs-td :data="Timemodel.startTime">{{
                      Timemodel.startTime
                    }}</vs-td>
                    <vs-td :data="Timemodel.endTime">{{
                      Timemodel.endTime
                    }}</vs-td>

                    <!-- <vs-td class="whitespace-no-wrap">
                      <feather-icon
                        icon="EditIcon"
                        title="edit"
                        svgClasses="w-5 h-5 text-warning hover:text-primary stroke-current cursor"
                        @click.stop="editTimemodel(Timemodel.timeperiodId)"
                        class="ml-2"
                      />
                      <feather-icon
                        icon="TrashIcon"
                        title="delete"
                        svgClasses="w-5 h-5 text-warning hover:text-primary stroke-current cursor"
                        @click.stop="
                          stateChange('Timemodel');
                          editJobsPopup = true;
                          delId = Timemodel.id;
                        "
                        class="ml-2"
                      />
                    </vs-td> -->
                  </vs-tr>
                </template>
              </vs-table>
              <div class="centerx">
                <vs-popup
                  classContent="popup-example"
                  :title="$t('setup.label.DeleteRUM')"
                  :active.sync="editJobsRumPopup"
                  class="popup-close mid-popup"
                >
                  <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
                    <div class="vx-col sm:w-full w-full">
                      <div class="vx-col sm:w-full w-full">{{ $t("system.label.areYouSureDelete") }}</div>
                    </div>
                  </div>
                  <div class="vx-row">
                    <span class="ml-4 mr-1">
                      <vs-button
                        type="border"
                        @click="editJobsRumPopup = false"
                        >{{ $t("setup.label.Cancel") }}</vs-button
                      >
                    </span>
                    <span class="ml-1 mr-2">
                      <vs-button
                        @click="deleteRumTeam(delId)"
                        color="warning"
                        >{{ $t("setup.label.Ok") }}</vs-button
                      >
                    </span>
                  </div>
                </vs-popup>
              </div>
            </vx-card>
          </vs-tab>
          <vs-tab :label="$t('setup.label.UsageRatePlan')">
            <vx-card>
              <vs-table
                :max-items="paginationItems[1]"
                pagination
                :data="products"
                :description="false"
                @selected="handleSelected5"
                search
                :description-items="paginationItems"
                description-title="Registries"
                description-connector="of"
                description-body="Pages"
              >
                <template slot="header">
                  <div class="heading">
                    {{ $t("setup.label.UsageRatePlan") }}
                  </div>
                  <div class="mr-2 mb-1 order-1">
                    <vs-button
                      icon-pack="feather"
                      icon="icon-plus"
                      @click="
                        $router.push({
                          name: 'Create Usage Rating',
                        })
                      "
                      size="small"
                      >{{ $t("setup.label.CreateUsageRatePlan") }}</vs-button
                    >
                  </div>
                </template>
                <template slot="thead">
                  <vs-th>{{ $t("setup.label.Id") }}</vs-th>
                  <vs-th>{{ $t("setup.label.PlanName") }}</vs-th>
                  <vs-th>{{ $t("setup.label.ProductName") }}</vs-th>
                  <vs-th>{{ $t("setup.label.RatePlanName") }}</vs-th>
                  <vs-th>{{ $t("setup.label.ChargeCode") }}</vs-th>
                  <vs-th>{{ $t("setup.label.TimemodelName") }}</vs-th>
                  <vs-th>{{ $t("setup.label.RatingType") }}</vs-th>
                  <vs-th>{{ $t("setup.label.RumName") }}</vs-th>
                  <!-- <vs-th>{{ $t("label.heading.actions") }}</vs-th> -->
                </template>

                <template slot-scope="{ data }">
                  <vs-tr
                    :key="index"
                    :data="products"
                    v-for="(products, index) in data"
                  >
                    <vs-td :data="products.id">{{ products.id }}</vs-td>
                    <vs-td :data="products.planDesc">{{
                      products.planDesc
                    }}</vs-td>
                    <vs-td :data="products.productDesc">{{
                      products.productDesc
                    }}</vs-td>
                    <vs-td :data="products.ratePlanName">{{
                      products.ratePlanName
                    }}</vs-td>
                    <vs-td :data="products.chargeCode">{{
                      products.chargeCode
                    }}</vs-td>
                    <vs-td :data="products.timeModelName">{{
                      products.timeModelName
                    }}</vs-td>
                    <vs-td :data="products.ratingType">{{
                      products.ratingType
                    }}</vs-td>
                    <vs-td :data="products.rumName">{{
                      products.rumName
                    }}</vs-td>

                    <!-- <vs-td class="whitespace-no-wrap">
                    <feather-icon
                      icon="EditIcon"
                      title="edit"
                      svgClasses="w-5 h-5 hover:text-primary stroke-current cursor"
                      @click.stop="editChannelMapping(products.productId)"
                      class="ml-2"
                    />
                  </vs-td> -->
                  </vs-tr>
                </template>
              </vs-table>
            </vx-card>
          </vs-tab>
        </vs-tabs>
      </div>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="'Delete ' + $t('setup.label.TemplateDefinition')"
        :active.sync="editJobsPopup"
        class="popup-close small-popup"
      >
        <div class="center">
          <img src="@/assets/images/pages/delete.svg" />
          <div class="success-msg">{{$t("setup.label.Are_you_sure_you_want_to_delete_?")}}</div>
        </div>

        <div class="center">
          <span class="p-2">
            <vs-button type="border" @click="editJobsPopup = false">{{
              $t("setup.label.Cancel")
            }}</vs-button></span
          >

          <span class="p-2">
            <vs-button @click="deleteTemplateDefinition(delId)">{{
              $t("setup.label.Confirm")
            }}</vs-button>
          </span>
        </div>
        <div style="height: 20px"></div>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      delId: 0,
      deleatId: 0,
      editJobsPopup: false,
      editJobsUomPopup: false,
      editJobsRumPopup: false,
      // provisioningRumList: [],
      // hardwareUomList: [],
      provisioningActionsList: [],
      networkElementList: [],
      timeList: [],
    };
  },
  components: { AtomSpinner },

  computed: {
    ...mapState({
      hardwareUomList: (state) => state.usageRating.Uomlist,
      provisioningRumList: (state) => state.usageRating.Rumlist,
      Timemodel: (state) => state.usageRating.GetTimePeriod,
      broadcasters: (state) => state.usageRating.GetTemplate,
      products: (state) => state.usageRating.GetUsageRatePlan,
      timemodel: (state) => state.usageRating.timeModelList,
    }),
  },
  methods: {
    EditTemplateData(id) {
      this.$router.push({ name: "Edit Template", params: { id: id } });
    },

    async getProductMapping() {
      this.loading = true;
      try {
        this.$store.dispatch("usageRating/setUsageRatePlanList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async getbroadcasterData() {
      this.loading = true;
      try {
        this.$store.dispatch("usageRating/setTemplateList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async getTimeModelData() {
      try {
        this.$store.dispatch("usageRating/setTimePeriodList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getUomData() {
      this.loading = true;
      try {
        this.$store.dispatch("usageRating/setUomList", {});
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
    async getCommandData() {
      this.loading = true;
      try {
        this.$store.dispatch("usageRating/setRumList");
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },

    editCreateDevice(id) {
      this.$router.push({ name: "Edit UOM", params: { id: id } });
    },
    editCreatesystem(id) {
      this.$router.push(`/editCreateSystem/${id}`);
    },
    editCreateCommand(id) {
      this.$router.push({ name: "Edit Rum", params: { id: id } });
    },
    handleSelected(hardwareUomList) {
      this.$router.push({
        name: "View UOM",
        params: { id: hardwareUomList.id },
      });
    },
    handleSelected1(broadcasters) {
      this.$router.push({
        name: "View Template",
        params: { id: broadcasters.templateId },
      });
    },
    handleSelected2(provisioningRumList) {
      this.$router.push({
        name: "View RUM",
        params: { id: provisioningRumList.id },
      });
    },
    handleSelected5(provisioningRumList) {
      this.$router.push({
        name: "View Usage Rating",
        params: { id: provisioningRumList.id },
      });
    },

    async deleteUomTeam(id) {
      try {
        await this.$store.dispatch(
          "usageRating/deleteUnitofMeasurementAction",
          id
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "UOM Successfully Deleted",
          type: "success",
        });
        this.getUomData();
        this.editJobsUomPopup = false;
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async deleteTemplateDefinition(id) {
      try {
        await this.$store.dispatch(
          "usageRating/deleteTemplateDefinitionAction",
          id
        );
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Template Definition Successfully Deleted",
          type: "success",
        });
        this.getbroadcasterData();
        this.editJobsPopup = false;
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async deleteRumTeam(id) {
      try {
        await this.$store.dispatch("usageRating/deleteRUMAction", id);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "RUM Successfully Deleted",
          type: "success",
        });
        this.getCommandData();
        this.editJobsRumPopup = false;
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
    async getTimemodelList() {
      this.loading = true;
      try {
        await this.$store.dispatch("usageRating/setTimeModelList");
        const myList = [];
        const myObj = {};
        if (this.timemodel.length == 0) return;
        for (const timeModel of this.timemodel) {
          myObj.timeModelName = timeModel.timemodelName;
          if (timeModel.year.length == 0) {
            myObj.startMonth = "-";
            myObj.endMonth = "-";
            myObj.startDay = "-";
            myObj.endDay = "-";
            myObj.startTime = "-";
            myObj.endTime = "-";
            myObj.startYear = "-";
            myObj.endYear = "-";
            myList.push({ ...myObj });
          }
          for (const year of timeModel.year) {
            myObj.startYear = year.startYear;
            myObj.endYear = year.endYear;
            if (year.month.length == 0) {
              myObj.startMonth = "-";
              myObj.endMonth = "-";
              myObj.startDay = "-";
              myObj.endDay = "-";
              myObj.startTime = "-";
              myObj.endTime = "-";
              myList.push({ ...myObj });
            }
            for (const month of year.month) {
              myObj.startMonth = month.startMonth;
              myObj.endMonth = month.endMonth;
              if (month.day.length == 0) {
                myObj.startDay = "-";
                myObj.endDay = "-";
                myObj.startTime = "-";
                myObj.endTime = "-";
                myList.push({ ...myObj });
              }
              for (const day of month.day) {
                myObj.startDay = day.startDay;
                myObj.endDay = day.endDay;
                if (day.time.length == 0) {
                  myObj.startTime = "-";
                  myObj.endTime = "-";
                  myList.push({ ...myObj });
                }
                for (const time of day.time) {
                  myObj.startTime = time.startTime;
                  myObj.endTime = time.endTime;
                  myList.push({ ...myObj });
                }
              }
            }
          }
        }
        this.timeList = myList;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },
  },
  mounted() {
    this.getUomData();
    this.getCommandData();
    this.getTimemodelList();
    this.getbroadcasterData();
    this.getProductMapping();
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
.inventory_tabSec >>> .con-vs-tabs .vs-tabs--ul {
  box-shadow: none !important;
}
.heading {
  margin-right: auto;
  font-size: 1.5rem;
  font-weight: 600;
  margin-left: 5px;
}
</style>
